
/**
 * Eliminates extra decimal places, rounding down to the specified number of decimals.
 * @param {number} x - The number to format.
 * @param {number} numberOfDecimals - The number of decimal places to keep.
 * @returns {string} - The formatted number as a string.
 */
export function decimalEliminate(x, numberOfDecimals) {
    return Number.parseFloat(x).toFixed(numberOfDecimals);
}

/**
 * Formats a number to three decimal places as a string.
 * @param {number} input - The number to format.
 * @returns {string} - The formatted number with three decimal places.
 */
export function decimalThree(input) {
    return input.toFixed(3);
}

/**
 * Formats a number to two decimal places as a string.
 * @param {number} input - The number to format.
 * @returns {string} - The formatted number with two decimal places.
 */
export function decimalTwo(input) {
    return input.toFixed(2);
}

/**
 * Obfuscates an email address by replacing '@' and '.' with '[at]' and '[dot]'.
 * @param {string} email - The email address to obfuscate.
 * @returns {string} - The obfuscated email address.
 */
export function obfuscateEmail(email) {
    if (!email) return '';
    return email.replace(/@/g, '[at]').replace(/\./g, '[dot]');
}

